import React from 'react';

const footerLinks = {
  product: {
    title: 'Produse',
    links: [
      { label: 'Ortexo', href: '/ortexo', page: 'ortexo' },
      { label: 'Borderou', href: '/borderou', page: 'borderou' },
      { label: 'Plicuri', href: '/corespondenta', page: 'corespondenta' }
    ]
  },
  company: {
    title: 'Companie',
    links: [
      { label: 'Despre noi', href: '/#companie' },
      { label: 'Misiune și viziune', href: '/#misiune' },
      { label: 'Echipă', href: '/#team' },
      { label: 'Contact', href: '/#contact' }
    ]
  },
  legal: {
    title: 'Legal',
    links: [
      { label: 'Confidențialitate', href: '/privacy-policy', page: 'privacy-policy' },
      { label: 'Termeni și Condiții', href: '/terms', page: 'terms' },
      { label: 'Cookie-uri', href: '/cookies', page: 'cookies' }
    ]
  }
};

export const Footer = ({ onNavigate }) => {
  const handlePageClick = (e, page) => {
    if (!onNavigate) return;
    e.preventDefault();
    onNavigate(page);
  };

  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-grid">
          <div>
            <a href="#" style={{ textDecoration: 'none', display: 'inline-block', marginBottom: '1rem' }}>
              <img
                src="/polytoollogo2000.png"
                alt="Poly Tool"
                style={{ height: '120px', width: 'auto' }}
              />
            </a>
            <p style={{
              fontSize: '0.875rem',
              color: 'var(--text-tertiary)',
              lineHeight: 1.6,
              maxWidth: '18rem',
              marginTop: '0.25rem'
            }}>
              Software pentru avocați, practicieni în insolvență și cabinete de contabilitate.
              Din 2018, din Constanța.
            </p>
            <p style={{
              fontSize: '0.75rem',
              color: 'var(--text-muted)',
              lineHeight: 1.5,
              maxWidth: '16rem',
              marginTop: '1rem'
            }}>
              Poly Tool Design S.R.L.<br />
              CUI: RO40293031 · J13/3628/2018
            </p>
          </div>

          <div className="footer-links">
            {Object.entries(footerLinks).map(([key, section]) => (
              <div key={key}>
                <h4 className="footer-section-title">{section.title}</h4>
                <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
                  {section.links.map((link) => (
                    <li key={link.label}>
                      {link.page ? (
                        <a
                          href={link.href}
                          className="footer-link"
                          onClick={(e) => handlePageClick(e, link.page)}
                        >
                          {link.label}
                        </a>
                      ) : (
                        <a href={link.href} className="footer-link">{link.label}</a>
                      )}
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>

        {/* ANPC Badges for Romanian compliance */}
        <div style={{
          display: 'flex',
          justifyContent: 'center',
          gap: '1rem',
          padding: '1.5rem 0',
          borderTop: '1px solid var(--border)',
          marginTop: '2rem'
        }}>
          <a
            href="https://anpc.ro/ce-este-sal/"
            target="_blank"
            rel="noopener noreferrer"
            style={{ opacity: 0.7, transition: 'opacity 0.2s ease' }}
            onMouseEnter={e => e.currentTarget.style.opacity = 1}
            onMouseLeave={e => e.currentTarget.style.opacity = 0.7}
          >
            <img
              src="https://wpfitness.eu/wp-content/uploads/2022/10/anpc-sal.png"
              alt="ANPC - Soluționarea Alternativă a Litigiilor"
              style={{ height: '50px', width: 'auto' }}
            />
          </a>
          <a
            href="https://ec.europa.eu/consumers/odr/main/index.cfm?event=main.home.chooseLanguage"
            target="_blank"
            rel="noopener noreferrer"
            style={{ opacity: 0.7, transition: 'opacity 0.2s ease' }}
            onMouseEnter={e => e.currentTarget.style.opacity = 1}
            onMouseLeave={e => e.currentTarget.style.opacity = 0.7}
          >
            <img
              src="https://wpfitness.eu/wp-content/uploads/2022/10/anpc-sol.png"
              alt="ANPC - Soluționarea Online a Litigiilor"
              style={{ height: '50px', width: 'auto' }}
            />
          </a>
        </div>

        <div className="footer-bottom">
          <p>© {new Date().getFullYear()} Poly Tool Design S.R.L. Toate drepturile rezervate.</p>
          <p>Constanța, România</p>
        </div>

        {/* Copyright & IP Notice */}
        <div style={{
          textAlign: 'center',
          paddingTop: '1rem',
          borderTop: '1px solid var(--border)',
          marginTop: '1rem'
        }}>
          <p style={{
            fontSize: '0.6875rem',
            color: 'var(--text-muted)',
            lineHeight: 1.6,
            maxWidth: '600px',
            margin: '0 auto'
          }}>
            Mărcile „Poly Tool", „Ortexo", „Borderou" și logo-urile asociate sunt proprietatea Poly Tool Design S.R.L.
            Toate celelalte mărci comerciale aparțin deținătorilor respectivi.
            Conținutul acestui site este protejat de legile drepturilor de autor din România și tratatele internaționale.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
